import { render } from "./StripPanel.vue?vue&type=template&id=8c5db486"
import script from "./StripPanel.vue?vue&type=script&lang=js"
export * from "./StripPanel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\bipom\\VSVN\\dude\\Web\\SmartLamp\\2.03\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__